import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import './Product.css';

const Product = (props) => {
    console.log(props);
    const {name, img, price, Chief, Cook} = props.product;
    return (
        <div className="product">
            <div className="food-image">
            <img src={img} alt="" />
            </div>
           <div>
           <h4 className="product-name">{name}</h4>
           <p>PRICE : $ {price}</p>
           <p className="product-chief">Chief Name: {Chief}</p>
           <p><i>BY : {Cook}</i></p>
           <button
           onClick={() => props.handleAddToCart(props.product)}

            className="btn-purchase">
              <FontAwesomeIcon icon = {faShoppingCart}></FontAwesomeIcon>
                Add to cart</button>
           </div>
        </div>
    );
};

export default Product;